module.exports = __webpack_public_path__ + "static/media/Renewal&Modification – Arabic.9652a41b.jpg";